import theme from '@ilg-totallymoney/ui/theme'
import styled from 'styled-components'

const StyledList = styled.ul`
    list-style: disc;
    font-size: 1.6rem;

    > li {
        margin-left: ${theme.space20};
        margin-bottom: ${theme.space10};
    }
`

const ContentList = ({ children }: { children: React.ReactNode }) => (
    <StyledList>{children}</StyledList>
)

export default ContentList
